import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';
import 'element-plus/dist/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index.scss' // global css

import ElIcons from './components/ElIcons'
import ElButtons from './components/ElButtons'
import BtnGroup from '@/components/BtnGroup'
import HeadImg from "@/components/HeadImg";
import UserInfoList from "@/components/resume/UserInfoList";


global.HOST = '/api'

const app = createApp(App)

app.directive('high-light', {
  updated: function (el, binding) {
    let value = binding.value;
    let changeValue = value.value;
    let array = changeValue.split('');
    let reg = /[0-9]+/;
    let allStr = '';
    for(let i=0;i<array.length;i++) {
      let str = array[i] + array[i+1];
      if(str == '微信' || str == '薇信' || str == '维信' || str == '威信' || str == 'VX' || str == 'vx' || str == 'Vx' || str == 'vX' || str == 'WX' || str == 'Wx' || str == 'wX' || str == 'wx' || str == '扣扣' || str == '抠抠' || str == 'QQ' || str == 'qq' || str == 'Qq' || str == 'qQ' || str == '纸条' || str == '回复') {
        allStr += "<font style='" + (value.backColor1?'background-color:'+value.backColor1+';':'') + (value.color1?'color:'+value.color1+';':'') + "'>" + str + "</font>";
        i += 1;
      }else if(reg.test(array[i]) || array[i] == '二' || array[i] == '三' || array[i] == '四' || array[i] == '五' || array[i] == '六' || array[i] == '七' || array[i] == '八' || array[i] == '九' || array[i] == '十' || array[i] == '壹' || array[i] == '贰' || array[i] == '叁' || array[i] == '肆' || array[i] == '伍' || array[i] == '陆' || array[i] == '柒' || array[i] == '捌' || array[i] == '玖' || array[i] == '拾' || array[i] == '零') {
        allStr += "<font style='" + (value.backColor2?'background-color:'+value.backColor2+';':'') + (value.color2?'color:'+value.color2+';':'') + "'>" + array[i] + "</font>";
      }else{
        allStr += array[i];
      }
    }
    el.innerHTML = allStr;
  }
})


app.component('ElIcons', ElIcons)
app.component('ElButtons', ElButtons)
app.component('BtnGroup', BtnGroup)
app.component('HeadImg', HeadImg)
app.component('UserInfoList', UserInfoList)
app.use(ElementPlus, { size: 'default', zIndex: 3000, locale: zhCn })
app.use(store).use(router).mount('#app')
